<script setup lang="ts">
import type { SpotDynamicContent } from 'types/blocks';
import type { ComponentStyles } from 'types/index';

defineProps<{
  data: SpotDynamicContent;
  componentStyles: ComponentStyles;
}>();
</script>

<template>
  <BaseComponentWrapper :component-styles="componentStyles">
    <div class="container">
      <PartialsSpotDynamic :data="data" />
    </div>
  </BaseComponentWrapper>
</template>
